import { Auth } from 'aws-amplify';
import config from '../config';

// API endpoint URL for the content management API
const API_ENDPOINT = config.api.url;

// Get submissions assigned to a judge
export async function getJudgeSubmissions() {
  try {
    // Get current authenticated user
    const user = await Auth.currentAuthenticatedUser();
    const judgeId = user.attributes.sub;
    
    // Call the API
    const response = await fetch(`${API_ENDPOINT}reviews/judge/${judgeId}`);
    
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    
    const data = await response.json();
    return data.submissions || [];
  } catch (error) {
    console.error('Error fetching judge submissions:', error);
    throw error;
  }
}

// Get submission details
export async function getSubmissionDetails(submissionId) {
  try {
    // Call the API
    const response = await fetch(`${API_ENDPOINT}reviews/submission/${submissionId}`);
    
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching submission details:', error);
    throw error;
  }
}

// Submit a review
export async function submitReview(reviewData, isDraft = false) {
  try {
    // Get current authenticated user
    const user = await Auth.currentAuthenticatedUser();
    const judgeId = user.attributes.sub;
    const judgeName = user.attributes.email || user.username;
    
    // Transform the new data structure to match the Lambda function expectations
    const transformedData = {
      submissionId: reviewData.submissionId,
      judgeId,
      judgeName,
      criteriaScores: reviewData.criteriaScores,
      criteriaComments: reviewData.criteriaComments,
      generalComments: reviewData.generalComments,
      finalScore: reviewData.finalScore,
      gradingCriteria: reviewData.gradingCriteria,
      status: isDraft ? 'draft' : 'submitted',
      isDraft
    };
    
    // Call the API
    const response = await fetch(`${API_ENDPOINT}reviews`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(transformedData),
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(`API error: ${response.status} - ${errorData.message || 'Unknown error'}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error submitting review:', error);
    throw error;
  }
}

// Save a review as draft
export async function saveReviewDraft(reviewData) {
  return submitReview(reviewData, true);
}

// Get reviews for a submission
export async function getSubmissionReviews(submissionId) {
  try {
    // Call the API
    const response = await fetch(`${API_ENDPOINT}reviews/submission/${submissionId}`);
    
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    
    const data = await response.json();
    return data.reviews || [];
  } catch (error) {
    console.error('Error fetching submission reviews:', error);
    throw error;
  }
}
